export enum ReleaseTarget {
  // All numbers
  All = 1,
  // Only whitelisted numbers
  Whitelist = 2
}

export type BackendFolder = {
  folderId: number;
  parentFolderId?: number;
  name?: string;
};

export type UserSimple = {
  userId: number;
  loginName: string;
  firstName: string;
  lastName: string;
  inactive: boolean;
  deleted: boolean;
};

export type BackendApplication = {
  applicationId?: string;
  name?: string;
  description?: string;
  folderId?: number;
  label?: string;
  companyId?: number;
  revision?: number;
  updated?: string;
  updatedBy?: UserSimple;
  created: string;
  createdBy?: UserSimple;
  revisionCreated?: string;
  revisionCreatedBy?: UserSimple;
  releaseTargetId?: number;
  releaseCreated?: string;
  releaseCreatedBy?: UserSimple;
};

export type BackendApplicationRevision = {
  applicationId: string;
  revision: number;
  blockData: string;
  comment?: string;
  created: string;
  createdBy?: UserSimple;
  releaseTargetId?: number;
  releaseCreated?: string;
  releaseCreatedBy?: UserSimple;
};

export type BlockDataBasic = {
  name?: string;
  label?: string;
  revision?: number;
  extensionData?: { [key: string]: object };
};

export type Configuration = {
  configurationId: number;
  configurationData?: string;
  created: string;
  createdBy: number;
};

export type ErrorResponse = {
  code?: number;
  message?: string;
};

export type Release = {
  releaseId?: string;
  applicationId?: string;
  revision?: number;
  isActive: boolean;
  created?: string;
  createdBy?: UserSimple;
  releaseTargetId: ReleaseTarget;
};

export type RemovedBackendApplication = BackendApplication & {
  removed?: string;
  removedBy?: UserSimple;
};
